export function getCurrentMonth() {
  const currentDate = new Date();
  const currentMonth = currentDate.toLocaleString("default", { month: "long" });
  return currentMonth;
}
